import { Link } from 'react-router-dom';
import { Clock, Eye } from 'lucide-react';
import type { HelpArticle } from '@/hooks/useHelp';

interface HelpArticleCardProps {
  article: HelpArticle;
  showCategory?: boolean;
}

export function HelpArticleCard({ article, showCategory = false }: HelpArticleCardProps) {
  const readTime = Math.max(1, Math.ceil(article.content.split(/\s+/).length / 200));

  return (
    <Link
      to={`/help/${article.category_slug}/${article.slug}`}
      className="group block rounded-lg border border-ds-line bg-ds-card p-5 shadow-card transition-all hover:shadow-card"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-semibold text-ds-text group-hover:text-ds-teal">
            {article.title}
          </h3>
          <p className="mt-1 text-sm text-ds-muted">{article.excerpt}</p>
          <div className="mt-3 flex items-center gap-4 text-xs text-ds-muted">
            {showCategory && (
              <span className="inline-flex items-center rounded-full bg-ds-neutral-tint px-2 py-0.5 font-medium text-ds-muted">
                {article.category_title}
              </span>
            )}
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {readTime} min
            </span>
            <span className="flex items-center gap-1">
              <Eye className="h-3 w-3" />
              {article.views_count}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
